import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import PortfolioDetail from './pages/PortfolioDetail';
import ScrollToTop from './components/utils/ScrollToTop';
import VisitorTracker from './components/utils/VisitorTracker';
import AdminLogin from './admin/pages/AdminLogin';
import AdminOtpVerify from './admin/pages/AdminOtpVerify';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminModulePage from './admin/pages/AdminModulePage';
import AdminLayout from './admin/components/AdminLayout';
import RequireAdminAuth from './admin/components/RequireAdminAuth';
import { AdminAuthProvider } from './admin/context/AdminAuthContext';
import { AdminThemeProvider } from './admin/context/AdminThemeContext';
import { WebsiteSectionsProvider } from './context/WebsiteSectionsContext';

const PublicLayout = ({ theme, onToggleTheme }) => (
  <WebsiteSectionsProvider>
    <div className="min-h-screen bg-white text-black transition-colors duration-300 dark:bg-black dark:text-white">
      <Navbar theme={theme} onToggleTheme={onToggleTheme} />
      <Outlet />
      <Footer />
    </div>
  </WebsiteSectionsProvider>
);

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <AdminAuthProvider>
      <Router>
        <ScrollToTop />
        <VisitorTracker />
        <Routes>
          <Route
            element={
              <AdminThemeProvider>
                <Outlet />
              </AdminThemeProvider>
            }
          >
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/verify-otp" element={<AdminOtpVerify />} />
            <Route
              path="/admin"
              element={
                <RequireAdminAuth>
                  <AdminLayout />
                </RequireAdminAuth>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="modules/:resourceKey" element={<AdminModulePage />} />
            </Route>
          </Route>

          <Route element={<PublicLayout theme={theme} onToggleTheme={toggleTheme} />}>
            <Route path="/" element={<Home theme={theme} onToggleTheme={toggleTheme} />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
          </Route>
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;
